<template>
  <div>
    <el-card class="box-card" v-loading="loading">
      <el-form :model="customerChange" ref="customerChangeRef" label-width="82px">
        <el-form-item label="保修卡号" class="addAdminForm">
          <el-input v-model="customerChange.sn" placeholder="请输入保修卡号"></el-input>
        </el-form-item>
        <el-form-item label="姓名" class="addAdminForm">
          <el-input v-model="customerChange.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="年龄" class="addAdminForm">
          <el-input v-model="customerChange.age" placeholder="请输入年龄"></el-input>
        </el-form-item>
        <el-form-item label="性别" class="addAdminForm">
          <el-radio v-model="customerChange.sex" label="1">男</el-radio>
          <el-radio v-model="customerChange.sex" label="2">女</el-radio>
        </el-form-item>
        <el-form-item label="新密码" class="addAdminForm">
          <el-input v-model="customerChange.newpassword" type="password" placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item class="mt20">
          <el-button type="primary" @click="clicksave">保存</el-button>
          <el-button type="info" @click="backCustomerManagement">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      loading: false,
      customerChange: {
        glassuserid: '',
        sn: '',
        name: '',
        age: '',
        sex: '1',
        newpassword: ''
      }
    }
  },
  mounted () {
  },
  methods: {
    LoadData (row) {
      this.customerChange.glassuserid = row.Id
      this.customerChange.sn = row.Sn
      this.customerChange.name = row.Name
      this.customerChange.age = row.Age
      this.customerChange.sex = row.Sex.toString()
    },
    backCustomerManagement () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiEditRefractiveDiscrepancyUser()
    },
    apiEditRefractiveDiscrepancyUser: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: this.customerChange.glassuserid,
        sn: this.customerChange.sn,
        name: this.customerChange.name,
        age: this.customerChange.age,
        sex: this.customerChange.sex,
        newpassword: this.customerChange.newpassword
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditRefractiveDiscrepancyUser, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.select1 {
    width: 109px;
    margin-right: 15px;
}
.speed {
    width: 440px;
    margin-right: 15px;
}
</style>
